document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-hover-swap]').forEach((el) => {
    if (el.dataset.hoverSwapBound) return;
    el.dataset.hoverSwapBound = 'true';

    // Desktop already gets the fade via CSS :hover. This click handler is
    // what makes it also work as "tap to reveal" on touch devices — toggling
    // a class rather than preventing default, so a wrapping <a> still
    // navigates normally.
    el.addEventListener('click', () => {
      el.classList.toggle('is-active');
    });
  });
});
